const LANG_PL = 'pl';
const LANG_EN = 'en';

const LANG_PL_CODES = ['pl-PL', 'pl_PL'];

const LANG_DEFAULT = LANG_PL;
const LANG_AVAILABLE = [LANG_PL, LANG_EN];

// Do not switch to ES6 export - sitemap-builder script needs to import this constants in ES5 syntax
module.exports = {
  LANG_DEFAULT,
  LANG_AVAILABLE,
  LANG_PL,
  LANG_EN,
  LANG_PL_CODES
};



// WEBPACK FOOTER //
// ./src/common/consts/language-code.js